import { useRef, useEffect } from "../_snowpack/pkg/react.js";

export default function usePreviousValue(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
